/* istanbul ignore file */
export { default } from './ErrorBlock';
